module.exports = __webpack_public_path__ + "img/key.42024454.svg";